import { RecordBuilder } from "slotworks/server/builders/record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import WrapperMediator from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import RainbowStacksSpinRecord from "./schema/spin-record";
import { BuyoutTypes } from "components/bonus-buy/bonus-buy-container";
import { SpinResponseSchema } from "./spin-record-builder";
import BuyoutRecord from "./schema/buyout-record";

class RainbowStacksBuyoutRecordBuilder implements RecordBuilder {
    public filter(data: any): boolean {
        let spinResponse: SpinResponseSchema;

        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
        }

        return spinResponse && spinResponse.RESULTS !== undefined && spinResponse.RESULTS.state?.game?.includes("BUYOUT");
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let spinResponse: SpinResponseSchema;

        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
            WrapperMediator.roundStarted(spinResponse.RESULTS.round_id);
            WrapperMediator.spinResponseReceived(spinResponse);
        }

        gameplay.id = spinResponse.RESULTS.round_id.toString();


        const record = new BuyoutRecord();
        record.creditsWon = 0;
        record.results = [];
        record.freespinsWon = 0;

        BUYOUT_MAP.forEach((value: {type: BuyoutTypes, symbol: string}, key: string) => {
            if (spinResponse.RESULTS.state.game.includes(key)) {
                record.type = value.type;
                record.jackpotSymbol = value.symbol;
            }
        });

        if (record.type == BuyoutTypes.FREESPIN) {
            record.freespinsWon = spinResponse.RESULTS.next_game_state?.total || 0;
        }
        record.totalBetCash = spinResponse.RESULTS.total_bet_cash;

        return [record];
    }
}

export default new RainbowStacksBuyoutRecordBuilder();

const BUYOUT_MAP = new Map<string, {type: BuyoutTypes, symbol: string}>([
    ["MINI", { type: BuyoutTypes.JACKPOT_MINI, symbol: "J4"}],
    ["MAXI", { type:BuyoutTypes.JACKPOT_MAXI, symbol: "J3"}],
    ["MAJOR", { type: BuyoutTypes.JACKPOT_MAJOR, symbol: "J2"}],
    ["GRAND", { type: BuyoutTypes.JACKPOT_GRAND, symbol: "J1"}],
    ["SPINS", {type: BuyoutTypes.FREESPIN, symbol: ""}]
]); 

const SYMBOLS = [
    "J4", "J3", "J2", "J1", ""
]



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/revolver/buyout-record-builder.ts